var React = require('react');

function CheckIcon2024 (props) {
    return React.createElement("svg",props,[React.createElement("g",{"id":"np_check_929005_000000 3","clipPath":"url(#clip0_607_989)","key":0},React.createElement("path",{"className":"primary-fill","fillRule":"evenodd","clipRule":"evenodd","d":"M5.60295 17.6667C6.26041 18.3168 7.33512 18.2588 7.91905 17.5426L18.5443 4.50796C19.0908 3.83727 18.9902 2.84997 18.3195 2.30337C17.6488 1.75684 16.6615 1.85747 16.1149 2.52815L6.59602 14.2377L2.98834 10.675C2.37275 10.066 1.3803 10.0719 0.772088 10.6875C0.163103 11.303 0.168989 12.2955 0.784576 12.9037L5.60203 17.6676"})),React.createElement("defs",{"key":1},React.createElement("clipPath",{"id":"clip0_607_989"},React.createElement("rect",{"width":"18.8057","height":"18.8057","transform":"translate(0.320312 0.90918)"})))]);
}

CheckIcon2024.defaultProps = {"width":"20","height":"20","viewBox":"0 0 20 20","fill":"none"};

module.exports = CheckIcon2024;

CheckIcon2024.default = CheckIcon2024;
